import * as types from './mutation-types'

export const mutations = {
  [types.LOGIN_LOADING](state) {
    state.token.loading = true
    state.token.data = null
    state.token.error = false
  },
  [types.LOGIN_ERROR](state, error) {
    state.token.loading = false
    state.token.data = null
    state.token.error = error
  },
  [types.LOGIN_COMPLETE](state, payload) {
    state.token.loading = false    
    state.token.data = payload
    state.token.error = false
  },
  [types.AUTH_LOGOUT]: (state, payload) => {    
    localStorage.removeItem('token')
    state.isAuthenticated = false
  },
  [types.SET_TOKEN]: (state, payload) => {    
      state.isAuthenticated = localStorage.getItem('token') ? true : false
  },  
  [types.RESET_PASSWORD_LOADING](state) {
    state.resetPassword.loading = true
    state.resetPassword.data = null
    state.resetPassword.error = false
  },
  [types.RESET_PASSWORD_ERROR](state, error) {
    state.resetPassword.loading = false
    state.resetPassword.data = null
    state.resetPassword.error = error
  },
  [types.RESET_PASSWORD_COMPLETE](state, payload) {
    state.resetPassword.loading = false
    state.resetPassword.data = payload
    state.resetPassword.error = false
  },  
  [types.USER_CREATE_LOADING](state) {
    state.user.loading = true
    state.user.data = null
    state.user.error = false
  },
  [types.USER_CREATE_ERROR](state, error) {
    state.user.loading = false
    state.user.data = null
    state.user.error = error
  },
  [types.USER_CREATE_COMPLETE](state, payload) {    
    state.user.loading = false
    state.user.data = payload
    state.user.error = false
  },
  [types.VERIFY_PHONE_NUMBER_LOADING](state) {
    state.verifyPhoneNumber.loading = true
    state.verifyPhoneNumber.data = null
    state.verifyPhoneNumber.error = false
  },
  [types.VERIFY_PHONE_NUMBER_ERROR](state, error) {
    state.verifyPhoneNumber.loading = false
    state.verifyPhoneNumber.data = null
    state.verifyPhoneNumber.error = error
  },
  [types.VERIFY_PHONE_NUMBER_COMPLETE](state, payload) {
    state.verifyPhoneNumber.loading = false
    state.verifyPhoneNumber.data = payload
    state.verifyPhoneNumber.error = false
  },
  [types.SET_REDIRECT_AFTER_AUTH](state, payload) {
    state.redirectAfterAuth = payload
  },
  [types.CLEAR_REDIRECT_AFTER_AUTH](state) {
    state.redirectAfterAuth = null
  }  
}



//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/auth/mutations.js
// module id = null
// module chunks = 